module.exports = __webpack_public_path__ + "img/9788932915852.171235b9.jpg";